import React, { lazy } from 'react';
import { Gift } from 'lucide-react';
const bonuses = [{
  num: '01',
  icon: 'https://cdn.magicpatterns.com/uploads/9r6s4KmoQzKEGyRS4UsLPZ/Portada_Bono_1_web_png.png',
  title: 'Mapa Rápido de Sueño en 10 Minutos',
  subtitle: 'Descubrí exactamente qué está frenando el sueño de tu hijo',
  desc: 'Y por cuál tomo empezar — en menos de 10 minutos.',
  value: '$8.500'
}, {
  num: '02',
  icon: 'https://cdn.magicpatterns.com/uploads/jwnAt5g8hRk9XaWhK4UKfn/Portada_Bono_2_web_png.png',
  title: 'Checklist de la Noche Perfecta',
  subtitle: 'Revisá en 2 minutos todo lo que importa',
  desc: 'Para que tu hijo duerma bien — con checklist por edad, por situación y tracker semanal para imprimir.',
  value: '$9.000'
}, {
  num: '03',
  icon: 'https://cdn.magicpatterns.com/uploads/jkT8DzoisCXXU84a8BjEBC/Portada_Bono_3_web_png.png',
  title: 'Guiones Exactos Para Calmar y Dormir',
  subtitle: 'Sabé exactamente qué decir en los momentos más difíciles',
  desc: 'Scripts listos para miedo, pesadillas, despertares y resistencia al acostarse.',
  value: '$10.000'
}, {
  num: '04',
  icon: 'https://cdn.magicpatterns.com/uploads/wryHLkxi4QGWdhifJJKNXL/Portada_Bono_4_web_png.png',
  title: 'Kit Visual de Emergencia Para Noches Difíciles',
  subtitle: 'Actuá con claridad cuando la noche explota',
  desc: 'Protocolos visuales, árboles de decisión y rescue cards para imprimir y tener en la mesa de luz.',
  value: '$9.000'
}];
// Subtle starfield SVG background — encoded inline for a calm constellation texture
const STAR_TEXTURE = "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='200' viewBox='0 0 200 200'><g fill='%23D4B96A' fill-opacity='0.12'><circle cx='20' cy='30' r='0.8'/><circle cx='60' cy='80' r='0.6'/><circle cx='110' cy='40' r='0.9'/><circle cx='150' cy='100' r='0.7'/><circle cx='180' cy='150' r='0.8'/><circle cx='40' cy='160' r='0.6'/><circle cx='90' cy='190' r='0.7'/><circle cx='130' cy='170' r='0.5'/><circle cx='170' cy='20' r='0.6'/><circle cx='10' cy='110' r='0.7'/></g></svg>\")";
export function BonusSection() {
  return <section id="bonos" className="py-20 bg-charcoal" data-id="element-25">
      <div className="max-w-container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-26">
        <div className="text-center mb-16" data-id="element-27">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gold/10 text-gold mb-6" data-id="element-28">
            <Gift className="w-8 h-8" data-id="element-29" />
          </div>
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-4 text-white" data-id="element-30">
            4 Bonos Estratégicos
          </h2>
          <p className="text-xl text-gray-300 font-medium" data-id="element-31">Siempre incluidos</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-32">
          {bonuses.map((bonus, i) => <div key={i} className="relative rounded-2xl border border-white/10 hover:border-gold/40 transition-all duration-300 shadow-lg hover:shadow-gold/10 overflow-hidden" style={{
          backgroundColor: '#0D1B3E',
          backgroundImage: STAR_TEXTURE,
          backgroundSize: '200px 200px',
          backgroundRepeat: 'repeat'
        }} data-id="element-33">
              <div className="flex flex-col sm:flex-row items-start gap-6 sm:gap-8 p-7 md:p-9" data-id="element-34">
                {/* Left: Image with glow OR fallback number */}
                {bonus.icon ? <div className="shrink-0 relative w-full sm:w-auto flex justify-center" data-id="element-35">
                    {/* Soft glow */}
                    <div className="absolute inset-0 bg-gold/20 blur-3xl scale-90 opacity-60" aria-hidden="true" data-id="element-36" />
                    <img src={bonus.icon} alt={bonus.title} className="relative z-10 w-36 md:w-44 object-contain drop-shadow-2xl" loading="lazy" decoding="async" data-id="element-37" />
                  </div> : <div className="shrink-0 flex items-center justify-center w-36 md:w-44 h-44 rounded-xl bg-night-lighter/40 border border-white/5" data-id="element-38">
                    <span className="text-6xl font-serif font-bold text-gold/30" data-id="element-39">
                      {bonus.num}
                    </span>
                  </div>}

                {/* Right: Text content */}
                <div className="flex-1 min-w-0" data-id="element-40">
                  {/* Pill badge */}
                  <div className="inline-flex items-center mb-4" data-id="element-41">
                    <span className="inline-block bg-gold text-charcoal font-bold text-sm tracking-wider px-3 py-1 rounded-full shadow-sm" data-id="element-42">
                      {bonus.num}
                    </span>
                  </div>

                  {/* Title */}
                  <h3 className="font-bold text-2xl md:text-3xl text-white mb-3 leading-tight tracking-tight" data-id="element-43">
                    {bonus.title}
                  </h3>

                  {/* Subtitle (lavender) */}
                  <p className="text-lg font-semibold text-lavender-light mb-4 leading-snug" data-id="element-44">
                    {bonus.subtitle}
                  </p>

                  {/* Gold divider */}
                  <div className="h-px w-16 mb-4" style={{
                background: 'linear-gradient(90deg, transparent, #C9972A, transparent)'
              }} data-id="element-45" />

                  {/* Body */}
                  <p className="text-base text-gray-300 mb-6 leading-relaxed" data-id="element-46">
                    {bonus.desc}
                  </p>

                  {/* Price row */}
                  <div className="flex items-center gap-3 text-lg pt-2" data-id="element-47">
                    <span className="text-red-500/80 line-through font-medium" data-id="element-48">
                      {bonus.value}
                    </span>
                    <span className="font-bold text-gold text-xl tracking-wide" data-id="element-49">
                      GRATIS
                    </span>
                  </div>
                </div>
              </div>
            </div>)}
        </div>

        <div className="mt-16 text-center bg-night-lighter text-white py-8 rounded-xl border border-gold shadow-lg" data-id="element-50">
          <p className="text-xl md:text-2xl font-medium" data-id="element-51">
            Valor total bonos{' '}
            <span className="line-through text-red-400 mx-3" data-id="element-52">$36.500</span>
            <span className="text-gold font-bold" data-id="element-53">
              → GRATIS con tu MegaPack
            </span>
          </p>
        </div>
      </div>
    </section>;
}